module.exports = __webpack_public_path__ + "img/Differentiation-CECA_10X_CC.85c450b9.png";